module.exports = __webpack_public_path__ + "img/logo-central-tanbun-indonesia.838c8d61.png";